import React from 'react';
import { PolylineF } from '@react-google-maps/api';

interface DroneHomePathProps {
  // The drone's current ("home") position.
  from: google.maps.LatLngLiteral;
  // The mission takeoff point.
  to: google.maps.LatLngLiteral;
}

const HOME_PATH_COLOR = '#00C4B4';

const MIN_HOME_PATH_DISTANCE_M = 16;

const DroneHomePath: React.FC<DroneHomePathProps> = ({ from, to }) => {
  const options = React.useMemo<google.maps.PolylineOptions>(() => {
    const arrow = (path: google.maps.SymbolPath, offset: string) => ({
      offset,
      icon: { path, scale: 2, strokeColor: HOME_PATH_COLOR, fillColor: HOME_PATH_COLOR, fillOpacity: 1, strokeOpacity: 1 },
    });

    return {
      strokeColor: HOME_PATH_COLOR,
      strokeOpacity: 1,
      strokeWeight: 3,
      clickable: false,
      zIndex: 50,
      icons: [
        arrow(google.maps.SymbolPath.FORWARD_CLOSED_ARROW, '100%'),
        arrow(google.maps.SymbolPath.BACKWARD_CLOSED_ARROW, '0%'),
      ],
    };
  }, []);

  const path = React.useMemo(() => [from, to], [from, to]);

  const distance = React.useMemo(
    () =>
      google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(from.lat, from.lng),
        new google.maps.LatLng(to.lat, to.lng),
      ),
    [from, to],
  );

  if (distance < MIN_HOME_PATH_DISTANCE_M) return null;

  return <PolylineF path={path} options={options} />;
};

export default DroneHomePath;
